import './JxToggle.css'; // pill track + sliding thumb, single concern (on/off)

/**
 * JxToggle — themed switch/toggle. Native checkbox kept underneath for accessibility/keyboard,
 * visually hidden — .jx-toggle-track is what's actually painted.
 *
 * @param {string} id
 * @param {boolean} checked
 * @param {(checked: boolean) => void} onChange
 * @param {string} [label]
 * @param {boolean} disabled
 */
export default function JxToggle({ id, checked, onChange, label, disabled = false }) {
    return (
        <label htmlFor={id} className={`jx-toggle-wrap${disabled ? ' jx-toggle-disabled' : ''}`}>
            <input
                id={id}
                type="checkbox"
                className="jx-toggle-native"
                checked={!!checked}
                onChange={(e) => onChange(e.target.checked)}
                disabled={disabled}
            />
            <span className={`jx-toggle-track${checked ? ' jx-toggle-track-on' : ''}`}>
                <span className="jx-toggle-thumb" />
            </span>
            {label && <span className="jx-toggle-label">{label}</span>}
        </label>
    );
}
